import React, { Component } from 'react'
import { connect } from 'react-redux'
import { selectMode } from '../../../actions/commonActions'
import VaultEncResAddCC from '../samples/VaultEncResAddCC'
const OBJECT = [  "encresaddcc", "encresaddcc", "encresaddcc"]
const METHODS = { 
    SetEncTrack2:[  ".SetEncTrack2(enc_track2);", ".SetEncTrack2(enc_track2);", "'enc_track2'=>$enc_track2"],
    SetDeviceType:[  ".SetDeviceType;", ".SetDeviceType;", "'device_type'=>$device_type"],
    SetCusId: [  ".SetCustId(cust_id);", ".setCustId(cust_id);", "'cust_id'=>$cust_id"],
    SetAvsCheck: [  ".SetAvsInfo(avsCheck);", ".setAvsInfo(avsCheck);", "$mpgTxn->setAvsInfo($mpgAvsInfo);"],
    SetEmail: [  ".SetEmail(email);", ".setEmail(email);", "'email'=>$email"],
    SetPhone: [  ".SetPhone(phone);", ".setPhone(phone);", "'phone'=>$phone"],
    SetNote: [  ".SetNote(note);", ".setNote(note);", "'note'=>$note"],
    SetDatkeyFormat: [  ".SetDataKeyFormat(data_key_format);", ".SetDataKeyFormat(data_key_format);", "'data_key_format'=>$data_key_format"],

    credit_card_number: [  ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    expiry_day: [  ".setExpdate(expiry_date);", ".setExpdate(expiry_date);", "'expdate'=>$expiry_date"],
    
    SetCryptType: [  ".SetCryptType(crypt);", ".setCryptType(crypt);", "'crypt_type'=>$crypt"],
    set_cot_info: [  ".SetCofInfo(cof);", ".setCofInfo(cof);", "$mpgTxn->setCofInfo($cof);"],
    set_issue_id: [  `{cof.SetIssuerId("VALUE_FOR_ISSUER_ID");}`, `{cof.SetIssuerId("VALUE_FOR_ISSUER_ID");}`, `{$cof->setIssuerId("VALUE_FOR_ISSUER_ID");}`],
}


export class VaultEncryptedAdd extends Component {
    componentDidMount() {
        this.props.selectMode('integration_guide')
        }
    render() { 
        const { progLangId } = this.props;
        return (
            <div className="stepPageContainer">  
            <div>
            <h3 className="stepPageTitle">Vault Encrypted Add Credit Card – EncResAddCC</h3>
            <p><b>Vault Encrypted Add Credit Card transaction object definition</b></p> 
            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>EncResAddCC encresaddcc = new EncResAddCC();

                            </code>
                        case 1:
                            return <code>EncResAddCC encresaddcc = new EncResAddCC();

                            </code>
                        case 2:
                            return <code>
                                {`$txnArray = array(‘type’=>’enc_res_add_cc', …);`}<br/>
                                {`$mpgTxn = new mpgTransaction($txnArray);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>
            <p><b>HttpsPostRequest object for Vault Encrypted Add Credit Card transaction</b></p>   
            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();</code>
                        case 1:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();</code>
                        case 2:
                            return <code>
                                {`$mpgRequest = new mpgRequest($mpgTxn);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>

                {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>mpgReq.SetTransaction(<b>encresaddcc</b>);</code>
                        case 1:
                            return  <code>mpgReq.SetTransaction(<b>encresaddcc</b>);</code>
                        case 2:
                            return <code>
                                {`$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);`}
                                </code>
                        default:
                            return null
                        }
                    })()}


        <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Vault Encrypted Add Credit Card transaction request fields – Required</h3>
        <p>For a full description of mandatory and optional values, see Appendix A Definition of Request Fields.</p>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                </tr>
                <tr>
                    <td>(missing or bad snippet)<br /></td>
                    <td>String<br/>(missing or bad snippet)</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetEncTrack2[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>(missing or bad snippet)</td>
                    <td>String</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetDeviceType[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>
                    electronic commerce indicator
                    </td>
                    <td> String<br/>1-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetCryptType[progLangId]}</code></td>
                </tr>                
                </tbody>
            </table>


        <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Vault Encrypted Add Credit Card transaction request fields – Optional</h3>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                </tr>
                <tr>
                    <td>customer ID</td>
                    <td>String<br/>
                        50-character alphanumeric<br/> 
                            <p className="note">
                                <strong>NOTE: </strong> 
                                Some special characters are not
                                allowed:
                                {`< > $ % = ? ^ { } [ ] \\`}
                            </p>
                        </td>
                        <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetCusId[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>AVS Information<br /></td>
                    <td>Object<br/>N/A</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetAvsCheck[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>email address<br /></td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetEmail[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>phone number<br /></td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetPhone[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>note</td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetNote[progLangId]}</code></td>
                </tr>

                <tr>
                    <td>data key format</td>
                    <td>String<br/>2-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetDatkeyFormat[progLangId]}</code></td>
                </tr>
                </tbody>
            </table>

            <p><b>Vault response fields</b></p>
            <p>For a list and explanation of (Receipt object) response fields that are available after sending this Vault
                transaction, see Definitions of Response Fields.
            </p>
          </div>
          <h3>Sample EncResAddCC</h3>
          <VaultEncResAddCC/>
        </div>
        )
    }
}

const mapStateToProps = state => {
    return { progLangId: state.common.progLangList.selection };
  }

export default connect(mapStateToProps,{selectMode})(VaultEncryptedAdd) 
